/**
 * Administrators store.
 *
 */

 import { Module, Action, getModule } from 'vuex-module-decorators';
 import PageBaseModule from '@/store/page';
 import store from '@/store';
 import PageEntity from '@/store/pageEntity';
 import { getList } from '@/api/crud';
 import ResponseHandlerModule from '@/store/modules/responseHandler';

 import { Administrators } from '@/models/administrators';
import { TableApiInterface } from '@/types/page/table';
 import filterModel from '@/store/administrators/filterModel';
 import AdministratorsFilter from '@/store/administrators/filterEntity';
 import { Filter } from '@/types/filter/filter';
import { formatPhone } from '@/lib/Utils';

 export const MODULE_NAME = Administrators.moduleName;

 @Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
 class AdministratorsModule extends PageBaseModule {
     filter: Filter;

     constructor(module: AdministratorsModule) {
         super(module);

         const page = new PageEntity();
         page.setModuleName(Administrators.moduleName);
         page.setTitle(Administrators.listTitle);
         page.setTitleAdd(Administrators.createTitle);
         page.setTitleEdit(Administrators.editTitle);
         page.values.actionPagination = 'administrators/updatePage';
         page.values.actionPageAmountItems = 'administrators/updatePageAmountItems';
         page.values.pageAmountItems = 50;
         this.pageSettings = page.values;
         this.pageSettings.routeName = `${Administrators.moduleName}_edit`;
         this.pageSettings.routeParam = `${Administrators.moduleName}Id`;

         const filter = new filterModel();
         this.filter = getModule(AdministratorsFilter);
         this.filter.setFilterName('AdministratorsFilter');
         this.filter.setTemplateClassName('template-lg directory-filters');
         this.filter.setFilterModel(filter.filterModel);
         this.filter.setFilterHandlers(filter.filterHandlers);
     }

     @Action({ rawError: true })
     async init() {
         await this.getList();
     }

     @Action({ rawError: true })
     async getList() {
         try {
             const sort = await this.getSortForRequest();
             const result = await getList(Administrators.apiPrefix,
                 {
                     page: this.pageSettings.pageCurrent,
                     items: this.pageSettings.pageAmountItems,
                 },
                 sort,
                 this.filter.filterSettings.filter,
             );
             const table = await this.context.dispatch('processList', result.table);
             await this.context.dispatch('setList', table);
         } catch (clientError: any) {
             const error = clientError.response.data;

             ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

             await this.context.dispatch('updatePage', 1);
         }
     }

     @Action({ rawError: true })
     processList(table: TableApiInterface): TableApiInterface {
        const fullNameTitleIndex = table.titles.findIndex((title) => title.id === 'fullName');
        const fullNameTitle = table.titles.splice(fullNameTitleIndex, 1)[0];
        table.titles.unshift(fullNameTitle);

        table.rows = table.rows.map(row => {
            row.managedClinics = row.managedClinics?.length ? row.managedClinics.map((clinic: { id: number; title: string }) => {
                return `<a href="/clinics/${clinic.id}" class="cp-table__item-link">${clinic.title}</a>`;
            }).join(', ') : '-';

            return {
                fullName: row.fullName,
                id: row.id,
                email: row.email,
                phone: row.phone ? formatPhone(row.phone as unknown as string) as any : '-',
                getRoleTitleForInactive: row.getRoleTitleForInactive,
                managedClinics: row.managedClinics,
                isActive: row.isActive,
            }
        });

        return table;
     }
 }

 export default getModule(AdministratorsModule);
